var Booking = {

    place: function (data, callback) {
        $.ajax({
            url: '/web/bookings',
            method: 'POST',
            data: data,
            success: function (result) {
                callback(result);
            },
            error: function () {
                callback();
            }
        });
    },
    
    payment: function (data, callback) {
        $.ajax({
            url: '/web/bookings/payment_url',
            method: 'POST',
            data: data,
            success: function (result) {
                callback(result);
            },
            error: function () {
                callback();
            }
        });
    },
    
};

module.exports = Booking;


// WEBPACK FOOTER //
// ./resources/scripts/portal/modules/Booking.js